const addGeoCountryCodeHeader = ({ countryCode }: { countryCode?: string | null }) =>
  countryCode
    ? {
        'wt-ipcountry': countryCode,
      }
    : {};

export default addGeoCountryCodeHeader;
